import { render, staticRenderFns } from "./return&refund.vue?vue&type=template&id=3788eb58&scoped=true"
import script from "./return&refund.vue?vue&type=script&lang=js"
export * from "./return&refund.vue?vue&type=script&lang=js"
import style0 from "./return&refund.vue?vue&type=style&index=0&id=3788eb58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3788eb58",
  null
  
)

export default component.exports